waitFor_jQuery(function () {
  $(document).ready(function (argument) {

    $(".view-container").on("click", function() {

      $(".quick-ship-variants")[0].style.display = "initial"
    })    

    $(".close-quick-ship").on("click", function() {

      $(".quick-ship-variants")[0].style.display = "none"
      
    })

    $(".quick-ship-variant").on("click", function() {

      $("input[name='id']")[0].value = this.dataset.id

      if (this.dataset.option1) {


        let select1 = $("select[name='option1'")[0]

        let optionVal = this.dataset.option1
        let regOptions = $(select1.parentElement).find(".product-options")
        let imageOptions = $(select1.parentElement).find(".product-option-modal")

        if (regOptions.length > 0) {
          regOptions = regOptions[0]
          for (let i = 0; i < regOptions.children.length; i++) {

            if(regOptions.children[i].innerText.trim().includes(optionVal)) {
              regOptions.children[i].click()
            }
          }
          
        } else if (imageOptions.length > 0) {

          let options = $(imageOptions[0]).find(".product-option-image-link")

          for (let i = 0; i < options.length; i++) {

            if(options[i].innerText.trim().includes(optionVal)) {
              options[i].click()
            }
          }
        }
        
      }
      
      if (this.dataset.option2) {

        let select2 = $("select[name='option2'")[0]

        let optionVal = this.dataset.option2
        let regOptions = $(select2.parentElement).find(".product-options")
        let imageOptions = $(select2.parentElement).find(".product-option-modal")

        if (regOptions.length > 0) {
          regOptions = regOptions[0]
          for (let i = 0; i < regOptions.children.length; i++) {

            if(regOptions.children[i].innerText.trim().includes(optionVal)) {
              regOptions.children[i].click()
            }
          }
          
        } else if (imageOptions.length > 0) {

          let options = $(imageOptions[0]).find(".product-option-image-link")

          for (let i = 0; i < options.length; i++) {

            if(options[i].innerText.trim().includes(optionVal)) {
              options[i].click()
            }
          }
        }
        
      }
      
      if (this.dataset.option3) {

        let select3 = $("select[name='option3'")[0]

        let optionVal = this.dataset.option3
        let regOptions = $(select3.parentElement).find(".product-options")
        let imageOptions = $(select3.parentElement).find(".product-option-modal")

        if (regOptions.length > 0) {
          regOptions = regOptions[0]
          for (let i = 0; i < regOptions.children.length; i++) {

            if(regOptions.children[i].innerText.trim().includes(optionVal)) {
              regOptions.children[i].click()
            }
          }
          
        } else if (imageOptions.length > 0) {

          let options = $(imageOptions[0]).find(".product-option-image-link")

          for (let i = 0; i < options.length; i++) {

            if(options[i].innerText.trim().includes(optionVal)) {
              options[i].click()
            }
          }
        }
        
      }

      $(".quick-ship-variants")[0].style.display = "none"
      
    })
    
  })
});